(ns measure.messages)

(def adset-summary-report-messages
  {:success "Successfully generated Adset Data report"
   :failure "Failed to generate Adset Data report"})

(def impression-context-report-messages
  {:success "Successfully generated Impression Context Data report"
   :failure "Failed to generate Impression Context Data report"})

(def split-tests-report-messages
  {:success "Successfully generated Split Tests Data report"
   :failure "Failed to generate Split Tests Data report"})

(def product-store-messages
  {:success "Successfully generated Product report"
   :failure "Failed to generate Product report"})

(def custom-report-messages
  {:success "Successfully generated Custom report"
   :failure "Failed to generate Custom report"})

(def ui-messages
  {:report {:create {:adset_summary adset-summary-report-messages
                     :impression_context impression-context-report-messages
                     :split_tests split-tests-report-messages
                     :product_store product-store-messages
                     :custom custom-report-messages

                     :vast_adset_summary adset-summary-report-messages
                     :vast_split_tests split-tests-report-messages
                     :vast_custom custom-report-messages}
            :download {:success "Successfully downloaded report file"
                       :failure "Failed to download report file"}
            :delete {:success "Successfully deleted report"
                     :failure "Failed to delete report"}}
   :report-schedule {:create {:success "Successfully created report schedule"
                              :failure "Failed to create report schedule"}
                     :edit {:success "Successfully updated report schedule"
                            :failure "Failed to update report schedule"}
                     :delete {:success "Successfully deleted report schedule"
                              :failure "Failed to delete report schedule"}}})
